const formatTick = (value: string) => {
  const [hour, minute] = value.split(':');
  const hourInt = parseInt(hour, 10);
  const ampm = hourInt >= 12 ? 'Pm' : 'Am';
  const formattedHour = hourInt % 12 || 12;
  return `${formattedHour}:${minute} ${ampm}`;
};

export default formatTick;
